import { ContactMailSharp } from '@material-ui/icons';
import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';
import DesignCard from './DesignCard';

// import mouse from '../img/mouse.png';
import './dnd.css';

import MouseIcon from '@material-ui/icons/Mouse';
import mapIcon from './NodeTypeToIconMap';

export default memo(({ data }) => {

  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, grey, royalblue)', padding:'5px', color:'white', borderRadius:'20px', marginTop:'5px', marginLeft:'10px', marginRight:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'
}

const renderIcon = (selected) =>{
  if (selected == true)
  {
    return (
      // <MouseIcon fontSize='large' style={{color:'#8da5ed'}} draggable={false}/>
      <MouseIcon fontSize='medium' style={designerIconStyle} draggable={false}/>

      // <img draggable={false} draggable={false} src={mouse} width='50' height='50'></img>
    // <img draggable={false} style={{border: '4px solid lightblue' }} draggable={false} src={mouse} width='50' height='50'></img>
    )
  }

  return (
  // <img draggable={false} src={mouse} width='50' height='50'></img>
  <MouseIcon fontSize='medium' style={designerIconStyle} draggable={false}/>
  )


}

  const renderImage = () => {
    if (data.attributes.image == undefined || data.attributes.image == null || data.attributes.image=='')
    {
      return (<div/>)

      // if (data.attributes.images == undefined || data.attributes.images == null || data.attributes.images=="")
      //   return (<div/>)
      // else
      // {
      //   var image = data.attributes.image
      //   // var images = JSON.parse(data.attributes.images)
      //   const url = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/image/' + data.entity +'/' + image
      //   return (
      //     <div class="col">
      //     <img className='clickimage'  src={url} ></img>
      //     </div>
      //   );
      // }
    

    }
    else
    {
      var baseURL = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/image/'
      if (data.objectType == 'TASK') 
      {
        console.log("Task Type object")
        baseURL = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/tasks/image/'
      }

      if (data.objectType == 'SUBTASK') 
      {
        console.log("SubTask Type object")
        baseURL = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/subtasks/image/' + data.parentObjectType  + '/' + data.parentEntityName + '/'
      }

      const url = baseURL + data.entity +'/' + data.attributes.image

      console.log(url)

      return (
      <img className='clickimage'  src={url} ></img>
    );
    }

  }

    const [img, setImg] = useState(null);

    // const imgName = data.attributes.image
    // if (img == null)
    // {
    //   const requestOptions = {
    //     method: 'GET',
    //     headers: { 'Content-Type': 'img/png'}
    //   }


    //   fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/image/drag/1.png' , requestOptions)
    // .then (async response => {
    //   if (!response.ok) 
    //   {
    //     const error = (data && data.message) || response.status;
    //     console.log(error)
    //     return Promise.reject(error);

    //   }
    //   const data = await response.json();
    //   setImg(data);
    //   console.log("Got image: " + data)

    //   })
    //   .catch(error => {alert(error)});


    // }

    // const url = "data:image/png;base64,"  + img 
    // console.log("Selected: ")

    // console.log(data.isSelected)
    return (
    // <div className="designnode" class={(data.isSelected)?  "selected" : "notselected"}>
<div className="designnode">
  <Handle
    type="target"
    position="top"
    style={{ background: '#555' }}
    onConnect={(params) => console.log('handle onConnect', params)}
  />
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    {renderIcon(data.selected)}
    <br/>
    {renderImage()}      
  </div>
  <DesignCard icon={mapIcon("MouseNode")} attributes={data.attributes} name={data.label} />

  <Handle
    type="source"
    position="bottom"
    id="b2"
    style={{ bottom: -5, top: 'auto', background: '#555' }}
  />
</div>
  
  );

});